import { IconOtherEye } from '@doltech/icons/IconOtherEye';
import { IconOtherEyeInvisible } from '@doltech/icons/IconOtherEyeInvisible';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../../figma/colors-v2';
import { Typography } from '../../../../../figma/DesignSystemV2/Typography';

const Main = styled.div`
  display: inline-block;
  ::first-letter {
    font-size: 32px;
    font-weight: 700;
    font-family: noto-serif, serif;
  }
  .toggle-button-wrapper {
    min-width: 140px;
    display: inline-block;
    .toggle-button {
      cursor: pointer;
      display: inline-grid;
      grid-auto-columns: max-content;
      grid-auto-flow: column;
      align-items: center;
      overflow: hidden;
      gap: 8px;
      border-radius: 12px;
      padding: 4px 8px;
      max-width: 140px;
      background-color: ${colorsV2.black10};
      transition: all 0.3s ease;

      .icon {
        line-height: 0;
        font-size: 24px;
      }
      .text {
        font-size: 14px;
      }
    }
  }
`;

export const ToggleViewIdeaButton = ({ ideaEnabled, setIdeaEnabled }) => {
  return (
    <Main>
      <div
        aria-hidden
        onMouseDown={(e) => {
          e.preventDefault();
          setIdeaEnabled(!ideaEnabled);
        }}
        contentEditable={false}
        className="toggle-button-wrapper"
      >
        <div aria-hidden contentEditable={false} className="toggle-button">
          <div className="icon">{ideaEnabled ? <IconOtherEyeInvisible /> : <IconOtherEye />}</div>
          <Typography.Paragraph variant="medium/14" className="text">
            {ideaEnabled ? 'Từ vựng' : 'Dàn ý'}
          </Typography.Paragraph>
        </div>
      </div>
    </Main>
  );
};
